<template>
    <bubble-menu
        v-if="editor"
        ref="refRichTextBubbleMenu"
        :editor="editorBubbleMenu"
        :options="getTippyOptions"
    >
        <div v-for="(option, index) in options" :key="index">
            <SellsyAIMenu
                v-if="option === 'SellsyAI'"
                :editor="editorBubbleMenu"
                :option="option"
                :disabled="disabled"
                :typeRichText="typeRichText"
                :hash="hash"
                source="bubblemenu"
            />
        </div>
    </bubble-menu>
</template>

<script>
import SellsyAIMenu from './customoptions/SellsyAIMenu.vue';
import RichTextMixin from 'mixins/RichTextMixin';
export default {
    name: 'RichTextBubbleMenu',
    components: {
        SellsyAIMenu,
    },
    mixins: [RichTextMixin],
    props: {
        editorBubbleMenu: {
            type: Object,
            default: null,
        },
        typeRichText: {
            type: String,
            default: '',
        },
        hash: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            showBubbleMenu: true,
        };
    },
    computed: {
        getTippyOptions() {
            if (this.options.includes('SellsyAI')) {
                return {
                    arrow: false,
                    placement: 'bottom-end',
                    theme: 'sellsyai',
                    zIndex: 999,
                };
            }
            return {};
        },
    },
};
</script>

<style lang="scss">
.tippy-box[data-theme~='sellsyai'] {
    background-color: transparent;
    color: var(--colors-common-text-standard-on-color);

    .tippy-content {
        padding: 0;
    }
}
</style>
